exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "kubernetes-security-context-selector .sm-label-left {\n  border-bottom: 1px solid var(--color-seashell);\n}\nkubernetes-security-context-selector input[type=\"checkbox\"] {\n  margin-top: 1rem;\n}\nkubernetes-security-context-selector .form-group {\n  margin-top: 1rem;\n}\nkubernetes-security-context-selector kubernetes-se-linux-options-selector .row {\n  margin-top: .75rem;\n}\nkubernetes-security-context-selector kubernetes-capabilities-selector .table {\n  border-top: 2px solid var(--color-white);\n}\nkubernetes-security-context-selector kubernetes-capabilities-selector .table .table-remove-button {\n  padding: 0 0 1rem 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/kubernetes/src/container/securityContext/securityContextSelector.component.less
// module id = 3789
// module chunks = 0